
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fq6gA", function(module, exports) {

$parcel$export(module.exports, "getGlobalErrorCount", () => $823b8d03c72b8ec8$export$d06c0426664e7c08);
$parcel$export(module.exports, "default", () => $823b8d03c72b8ec8$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");
let $823b8d03c72b8ec8$var$shouldInitilizeGlobalErrorHandler = true;
let $823b8d03c72b8ec8$var$globalCount = 0;
const $823b8d03c72b8ec8$var$errors = [];
let $823b8d03c72b8ec8$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
    $823b8d03c72b8ec8$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
function $823b8d03c72b8ec8$export$ebe081a8c9bf8176(sinkFunc) {
    $823b8d03c72b8ec8$var$push = sinkFunc;
    $823b8d03c72b8ec8$var$errors.forEach((e)=>{
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $823b8d03c72b8ec8$var$errors.length = 0;
}
function $823b8d03c72b8ec8$export$d06c0426664e7c08() {
    return $823b8d03c72b8ec8$var$globalCount;
}
function $823b8d03c72b8ec8$var$handleError(e) {
    $823b8d03c72b8ec8$var$globalCount++;
    if (e.error?.UFOhasCaught === undefined) try {
        if (e.error instanceof Error) $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            const hint = JSON.stringify(e.error).slice(0, 50);
            $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } else if (e.message !== undefined) {
            const hint = e.message.slice(0, 50);
            $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        }
        if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $823b8d03c72b8ec8$var$handlePromiseRejection(e) {
    $823b8d03c72b8ec8$var$globalCount++;
    if (e.reason instanceof Error) $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        const hint = JSON.stringify(e.reason).slice(0, 50);
        $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $823b8d03c72b8ec8$var$setupUFOGlobalErrorHandler() {
    if ($823b8d03c72b8ec8$var$shouldInitilizeGlobalErrorHandler) {
        (0, $cBeZP.bind)(window, {
            type: 'error',
            listener: (e)=>$823b8d03c72b8ec8$var$handleError(e)
        });
        (0, $cBeZP.bind)(window, {
            type: 'unhandledrejection',
            listener: $823b8d03c72b8ec8$var$handlePromiseRejection
        });
        $823b8d03c72b8ec8$var$shouldInitilizeGlobalErrorHandler = false;
    }
}
var $823b8d03c72b8ec8$export$2e2bcd8739ae039 = $823b8d03c72b8ec8$var$setupUFOGlobalErrorHandler;

});

parcelRegister("jMqau", function(module, exports) {

$parcel$export(module.exports, "reportError", () => $5541cc01b74c4eaf$export$b33b857ad1d9900e);
$parcel$export(module.exports, "installErrorHandler", () => $5541cc01b74c4eaf$export$abd5747ea77ecab9);

var $VSDnB = parcelRequire("VSDnB");
const $5541cc01b74c4eaf$var$buffer = [];
let $5541cc01b74c4eaf$var$push = (payload)=>{
    $5541cc01b74c4eaf$var$buffer.push(payload);
};
function $5541cc01b74c4eaf$export$b33b857ad1d9900e(payload) {
    $5541cc01b74c4eaf$var$push(payload);
}
function $5541cc01b74c4eaf$export$abd5747ea77ecab9(handler) {
    if ((0, $VSDnB.fg)('moving_jira_entry-points_api_under_platform')) {
        $5541cc01b74c4eaf$var$push = handler;
        $5541cc01b74c4eaf$var$buffer.forEach((payload)=>handler(payload));
        $5541cc01b74c4eaf$var$buffer.length = 0;
    }
}

});

parcelRegister("1tcYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea2ed9c2ccea9583$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $ea2ed9c2ccea9583$export$11bcb6e9af2aca35);

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");
var $ea2ed9c2ccea9583$export$2e2bcd8739ae039 = (0, $6wxJn.default);
function $ea2ed9c2ccea9583$export$11bcb6e9af2aca35() {
    return (0, $5uXOq.useContext)((0, $6wxJn.default));
}

});

parcelRegister("21pfT", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", () => $41be1e74eab9e5f7$export$c08e7affcf78b064);

var $Y0qGc = parcelRequire("Y0qGc");

var $1a316 = parcelRequire("1a316");

var $7cRo8 = parcelRequire("7cRo8");

var $fCzt4 = parcelRequire("fCzt4");

var $bC5TE = parcelRequire("bC5TE");

var $dNz07 = parcelRequire("dNz07");

var $9mLUv = parcelRequire("9mLUv");

var $2OjhD = parcelRequire("2OjhD");
const $41be1e74eab9e5f7$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $fCzt4.visibilityChangeObserver).start();
            if (config.events[(0, $2OjhD.BMEventsType).WEB_VITALS]?.enabled) (0, $bC5TE.webVitalsObserver).start();
            if (config.debug) {
                (0, $1a316.logger).enable();
                (0, $9mLUv.submitter).setDebug(true);
                (0, $7cRo8.pageLoadMetaMetric).setDebug(true);
            }
            (0, $9mLUv.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $Y0qGc.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $dNz07.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $7cRo8.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $7cRo8.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $7cRo8.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $7cRo8.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $7cRo8.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $7cRo8.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $41be1e74eab9e5f7$export$c08e7affcf78b064 = $41be1e74eab9e5f7$var$makeBrowserMetrics();

});
parcelRegister("Y0qGc", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", () => $87294ec8a2d91847$export$9e87a201397ac0a9);
const $87294ec8a2d91847$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $87294ec8a2d91847$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("1a316", function(module, exports) {

$parcel$export(module.exports, "logger", () => $ce30b9b67753626e$export$af88d00dbe7f521);
const $ce30b9b67753626e$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("7cRo8", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", () => $eb7d2fead5730ef2$export$24b7a1a311eb05dc);

var $2OjhD = parcelRequire("2OjhD");

var $faqZ3 = parcelRequire("faqZ3");

var $hjsyZ = parcelRequire("hjsyZ");
class $eb7d2fead5730ef2$export$9609608c00ea5077 extends (0, $hjsyZ.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $faqZ3.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $eb7d2fead5730ef2$export$24b7a1a311eb05dc = new $eb7d2fead5730ef2$export$9609608c00ea5077({
    type: (0, $2OjhD.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("2OjhD", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", () => $b9090a2a775e8405$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $b9090a2a775e8405$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $b9090a2a775e8405$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $b9090a2a775e8405$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $b9090a2a775e8405$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $b9090a2a775e8405$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $b9090a2a775e8405$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $b9090a2a775e8405$export$983b017156c2aee2);
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $b9090a2a775e8405$export$5866f95702a15142);
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $b9090a2a775e8405$export$f087a59bd717e49d);
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $b9090a2a775e8405$export$b10c1d9a7db7765b);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $b9090a2a775e8405$export$60c0193054fc3040);

var $faqZ3 = parcelRequire("faqZ3");
var $b9090a2a775e8405$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $b9090a2a775e8405$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $b9090a2a775e8405$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $b9090a2a775e8405$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $b9090a2a775e8405$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $b9090a2a775e8405$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $b9090a2a775e8405$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $b9090a2a775e8405$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
const $b9090a2a775e8405$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $b9090a2a775e8405$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $b9090a2a775e8405$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $b9090a2a775e8405$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $b9090a2a775e8405$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("faqZ3", function(module, exports) {

$parcel$export(module.exports, "MetricState", () => $d0da0e1fa3f8875a$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $d0da0e1fa3f8875a$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $d0da0e1fa3f8875a$export$2bce4ffdd840e878);

var $bopkp = parcelRequire("bopkp");

var $1a316 = parcelRequire("1a316");

var $fCzt4 = parcelRequire("fCzt4");

var $dNRIi = parcelRequire("dNRIi");
var $d0da0e1fa3f8875a$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $d0da0e1fa3f8875a$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $d0da0e1fa3f8875a$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $d0da0e1fa3f8875a$export$2bce4ffdd840e878 {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $d0da0e1fa3f8875a$var$getPageVisibleState();
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $bopkp.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $1a316.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $d0da0e1fa3f8875a$var$getPageVisibleState();
        (0, $fCzt4.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $1a316.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $1a316.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $fCzt4.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return true;
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $1a316.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $fCzt4.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
	 *
	 * @param metric
	 * The array of Until metrics can be of two types
	 * This function returns an UntilExperience
	 */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $d0da0e1fa3f8875a$export$2bce4ffdd840e878 ? (0, $dNRIi.UntilExperience).fromMetric(metricOrConfig) : (0, $dNRIi.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $d0da0e1fa3f8875a$var$getPageVisibleState();
    }
}

});
parcelRegister("bopkp", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", () => $dba831f68643570c$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $dba831f68643570c$export$df21d285cfcda81e);
const $dba831f68643570c$export$1d17377365286b00 = [
    'ssr'
];
const $dba831f68643570c$export$df21d285cfcda81e = 7500;

});

parcelRegister("fCzt4", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $f980acfe8e701b39$export$13e680397ec8f3eb);
class $f980acfe8e701b39$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $f980acfe8e701b39$export$13e680397ec8f3eb = new $f980acfe8e701b39$var$VisibilityChangeObserver();

});

parcelRegister("dNRIi", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", () => $309914b4389d4632$export$3fcc0936ee2cc852);
class $309914b4389d4632$export$3fcc0936ee2cc852 {
    static{
        this.FMP = 'fmp';
    }
    static fromConfig(config) {
        return new $309914b4389d4632$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $309914b4389d4632$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
	 * If FMP mark is present, return that
	 * otherwise return the eventual load
	 */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$309914b4389d4632$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
	 * Get the time it takes for a segment to become fully interactable,
	 * regardless of whether it uses the FMP as the stop time. (Eventual load)
	 */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$309914b4389d4632$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});



parcelRegister("hjsyZ", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", () => $ae9e0b971909ad2b$export$fd1447b187f590fe);

var $1a316 = parcelRequire("1a316");

var $faqZ3 = parcelRequire("faqZ3");
class $ae9e0b971909ad2b$export$fd1447b187f590fe extends (0, $faqZ3.BaseMetric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $1a316.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $faqZ3.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $1a316.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $1a316.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $faqZ3.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $ae9e0b971909ad2b$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $ae9e0b971909ad2b$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($ae9e0b971909ad2b$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("bC5TE", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", () => $f290d4298ee5dd10$export$253d38dccbb37615);


class $f290d4298ee5dd10$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("4EeuU"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("fRY4k"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $f290d4298ee5dd10$export$253d38dccbb37615 = new $f290d4298ee5dd10$var$WebVitalsObserver();

});
parcelRegister("4EeuU", function(module, exports) {

let $362624c2ea09782a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $362624c2ea09782a$var$load("gceFf").then(()=>parcelRequire('gDSxx'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});



parcelRegister("fRY4k", function(module, exports) {

let $b8da66aad20ee1ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b8da66aad20ee1ca$var$load("8qy0v").then(()=>parcelRequire('8yzun'));

});


parcelRegister("dNz07", function(module, exports) {

$parcel$export(module.exports, "Route", () => $9487519eee4f783e$export$e7b0ac011bb776c6);
const $9487519eee4f783e$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("9mLUv", function(module, exports) {

$parcel$export(module.exports, "submitter", () => $6d437c00d0efd3b5$export$c21a25872e3f5a2b);

var $bFU4G = parcelRequire("bFU4G");

var $2OjhD = parcelRequire("2OjhD");

var $1VnMk = parcelRequire("1VnMk");

var $iFc5T = parcelRequire("iFc5T");
const $6d437c00d0efd3b5$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $iFc5T.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $2OjhD.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $bFU4G.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $1VnMk.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
    }
};

});
parcelRegister("1VnMk", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", () => $b5434d6816176e2f$export$896b6e121bbaec25);

var $bopkp = parcelRequire("bopkp");

var $1a316 = parcelRequire("1a316");

var $bZsxw = parcelRequire("bZsxw");

var $9uajf = parcelRequire("9uajf");

var $7jNuP = parcelRequire("7jNuP");

var $8Ic8h = parcelRequire("8Ic8h");

var $j9Eek = parcelRequire("j9Eek");

var $jLd46 = parcelRequire("jLd46");

var $5bSM4 = parcelRequire("5bSM4");

var $zvZP9 = parcelRequire("zvZP9");

var $5dXPl = parcelRequire("5dXPl");

var $plhgc = parcelRequire("plhgc");

var $hW0NK = parcelRequire("hW0NK");

var $z1c63 = parcelRequire("z1c63");

var $OV5vz = parcelRequire("OV5vz");

var $gqba1 = parcelRequire("gqba1");

var $h14Ri = parcelRequire("h14Ri");

var $18J7I = parcelRequire("18J7I");

var $3nXa3 = parcelRequire("3nXa3");

var $bqsDF = parcelRequire("bqsDF");

var $e12ut = parcelRequire("e12ut");

var $c4WOp = parcelRequire("c4WOp");

var $cecKe = parcelRequire("cecKe");

var $3CL6l = parcelRequire("3CL6l");

var $fOBx2 = parcelRequire("fOBx2");

var $aklN4 = parcelRequire("aklN4");

var $6FD20 = parcelRequire("6FD20");

var $lgaHS = parcelRequire("lgaHS");

var $3Rrh2 = parcelRequire("3Rrh2");

var $7hfO8 = parcelRequire("7hfO8");

var $glqAF = parcelRequire("glqAF");

var $fNOPT = parcelRequire("fNOPT");

var $j3CL9 = parcelRequire("j3CL9");

var $5qhne = parcelRequire("5qhne");

var $7nZqE = parcelRequire("7nZqE");

var $9sxxV = parcelRequire("9sxxV");

var $2OjhD = parcelRequire("2OjhD");
const $b5434d6816176e2f$var$defaultSet = [
    (0, $zvZP9.eventKey),
    (0, $OV5vz.eventType),
    (0, $plhgc.eventProduct),
    (0, $z1c63.eventRoute),
    (0, $jLd46.eventId),
    (0, $5dXPl.eventLocalTime),
    (0, $hW0NK.eventRegion),
    (0, $9uajf.appFramework),
    (0, $7jNuP.appVersion),
    (0, $8Ic8h.bmVersion),
    (0, $7hfO8.telemetryBrowser),
    (0, $glqAF.telemetryCpu),
    (0, $fNOPT.telemetryMemory),
    (0, $j3CL9.telemetryNetwork),
    (0, $j9Eek.customData),
    (0, $gqba1.featureFlags),
    (0, $h14Ri.hostname),
    (0, $6FD20.productCustomData),
    (0, $5qhne.appTimings),
    (0, $9sxxV.resourceTimings)
];
const $b5434d6816176e2f$var$pageLoadCommon = [
    ...$b5434d6816176e2f$var$defaultSet,
    (0, $fOBx2.pageVisibleState),
    (0, $aklN4.pageVisibleValue),
    (0, $5bSM4.eventInitial),
    (0, $c4WOp.pageLoadMetrics),
    (0, $7nZqE.bundleEvalTimings)
];
const $b5434d6816176e2f$var$initialPageLoadSet = [
    ...$b5434d6816176e2f$var$pageLoadCommon,
    (0, $3nXa3.initialPageLoadMetrics),
    (0, $e12ut.navigationMetrics),
    (0, $3Rrh2.ssrSuccess),
    (0, $lgaHS.ssrFeatureFlags)
];
const $b5434d6816176e2f$var$spaTransitionSet = [
    ...$b5434d6816176e2f$var$pageLoadCommon
];
const $b5434d6816176e2f$var$pageSegmentLoadSet = [
    ...$b5434d6816176e2f$var$defaultSet,
    (0, $cecKe.pageSegmentLoadMetrics),
    (0, $fOBx2.pageVisibleState),
    (0, $aklN4.pageVisibleValue),
    (0, $5bSM4.eventInitial),
    (0, $7nZqE.bundleEvalTimings)
];
const $b5434d6816176e2f$var$interactionSet = [
    ...$b5434d6816176e2f$var$defaultSet,
    (0, $fOBx2.pageVisibleState),
    (0, $aklN4.pageVisibleValue),
    (0, $bqsDF.interactionMetrics)
];
const $b5434d6816176e2f$var$customMetricSet = [
    ...$b5434d6816176e2f$var$defaultSet,
    (0, $fOBx2.pageVisibleState),
    (0, $aklN4.pageVisibleValue),
    (0, $18J7I.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $b5434d6816176e2f$var$webVitalsMetricSet = [
    ...$b5434d6816176e2f$var$defaultSet,
    (0, $3CL6l.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $b5434d6816176e2f$var$waitForCLS = (delay = (0, $bopkp.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $b5434d6816176e2f$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $1a316.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $2OjhD.BMEventsType).PAGE_LOAD && (0, $bZsxw.isPageLoadMetricData)(data) && data.isInitial) set = $b5434d6816176e2f$var$initialPageLoadSet;
    if (data.config.type === (0, $2OjhD.BMEventsType).PAGE_LOAD && (0, $bZsxw.isPageLoadMetricData)(data) && !data.isInitial) set = $b5434d6816176e2f$var$spaTransitionSet;
    if (data.config.type === (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD && (0, $bZsxw.isPageSegmentLoadMetricData)(data)) set = $b5434d6816176e2f$var$pageSegmentLoadSet;
    if (data.config.type === (0, $2OjhD.BMEventsType).INLINE_RESULT) set = $b5434d6816176e2f$var$interactionSet;
    if (data.config.type === (0, $2OjhD.BMEventsType).CUSTOM) set = $b5434d6816176e2f$var$customMetricSet;
    if (data.config.type === (0, $2OjhD.BMEventsType).WEB_VITALS) {
        set = $b5434d6816176e2f$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $b5434d6816176e2f$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("bZsxw", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", () => $8a8179e6bf69b65d$export$b0e12e7abb0bff11);
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $8a8179e6bf69b65d$export$83d0099ee6dbb5b0);
$parcel$export(module.exports, "isPageLoadConfig", () => $8a8179e6bf69b65d$export$8672fa27ba8bba88);
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $8a8179e6bf69b65d$export$abe063537ef4987b);
$parcel$export(module.exports, "isInteractionConfig", () => $8a8179e6bf69b65d$export$ae68674b6a9353be);
$parcel$export(module.exports, "isCustomConfig", () => $8a8179e6bf69b65d$export$b493eb8b2ba87421);

var $2OjhD = parcelRequire("2OjhD");
const $8a8179e6bf69b65d$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $2OjhD.BMEventsType).PAGE_LOAD;
};
const $8a8179e6bf69b65d$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $8a8179e6bf69b65d$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $2OjhD.BMEventsType).PAGE_LOAD;
};
const $8a8179e6bf69b65d$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $8a8179e6bf69b65d$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $2OjhD.BMEventsType).INLINE_RESULT;
};
const $8a8179e6bf69b65d$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $2OjhD.BMEventsType).CUSTOM;
};

});

parcelRegister("9uajf", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $7ebabdbf24c9fe98$export$e34e4529b979f74c);
const $7ebabdbf24c9fe98$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("7jNuP", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $593f3c3cfdd9b91e$export$82ae485178b37419);
const $593f3c3cfdd9b91e$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("8Ic8h", function(module, exports) {

$parcel$export(module.exports, "bmVersion", () => $a996c517c928eee4$export$5cafa465fc876895);
const $a996c517c928eee4$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("j9Eek", function(module, exports) {

$parcel$export(module.exports, "customData", () => $26fd89fad3c47ede$export$f7e743c7db162193);
const $26fd89fad3c47ede$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("jLd46", function(module, exports) {

$parcel$export(module.exports, "eventId", () => $fd3e8851b2dbaa9c$export$aed28df7ac07d79a);
const $fd3e8851b2dbaa9c$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("5bSM4", function(module, exports) {

$parcel$export(module.exports, "eventInitial", () => $065f7a80483d1536$export$fa8e91d436b3ef8b);

var $bZsxw = parcelRequire("bZsxw");
const $065f7a80483d1536$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $bZsxw.isPageLoadMetricData)(data) && !(0, $bZsxw.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("zvZP9", function(module, exports) {

$parcel$export(module.exports, "eventKey", () => $40edfd4eb62e1855$export$10be2d3a558d3f88);

var $3SSyX = parcelRequire("3SSyX");
const $40edfd4eb62e1855$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $3SSyX.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("3SSyX", function(module, exports) {

$parcel$export(module.exports, "mapEventType", () => $6bf19b2de390745a$export$b334d07f11140768);

var $2OjhD = parcelRequire("2OjhD");
const $6bf19b2de390745a$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $2OjhD.BMEventsType).CUSTOM:
            return (0, $2OjhD.StorableBMEventsType).CUSTOM;
        case (0, $2OjhD.BMEventsType).INLINE_RESULT:
            return (0, $2OjhD.StorableBMEventsType).INLINE_RESULT;
        case (0, $2OjhD.BMEventsType).PAGE_LOAD:
            return (0, $2OjhD.StorableBMEventsType).PAGE_LOAD;
        case (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $2OjhD.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $2OjhD.BMEventsType).WEB_VITALS:
            return (0, $2OjhD.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("5dXPl", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", () => $fdfd11229c536b50$export$5219854ae7ec45da);

var $k7m40 = parcelRequire("k7m40");
const $fdfd11229c536b50$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $k7m40.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $k7m40.default)(new Date(), 'i'), 10)
    });

});

parcelRegister("plhgc", function(module, exports) {

$parcel$export(module.exports, "eventProduct", () => $236de010567e5ba1$export$a7df4e8088db8843);
const $236de010567e5ba1$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("hW0NK", function(module, exports) {

$parcel$export(module.exports, "eventRegion", () => $9c98147f0ffde594$export$d0117b71adcdebc0);
const $9c98147f0ffde594$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("z1c63", function(module, exports) {

$parcel$export(module.exports, "eventRoute", () => $1b1ee3885dec0024$export$44d3627af289ca16);
const $1b1ee3885dec0024$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("OV5vz", function(module, exports) {

$parcel$export(module.exports, "eventType", () => $9ecd37684592f4fe$export$4c045e605d532c98);

var $3SSyX = parcelRequire("3SSyX");
const $9ecd37684592f4fe$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $3SSyX.mapEventType)(config.type)
    };
};

});

parcelRegister("gqba1", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $e4a5e3d962b0f438$export$e62953d023125748);
const $e4a5e3d962b0f438$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("h14Ri", function(module, exports) {

$parcel$export(module.exports, "hostname", () => $85a6c61f12e50306$export$640106f6dc7d2706);
const $85a6c61f12e50306$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("18J7I", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", () => $d852d0e129cf440f$export$cab039265c52a2e9);

var $bZsxw = parcelRequire("bZsxw");
const $d852d0e129cf440f$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $bZsxw.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("3nXa3", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", () => $add2d86084023c49$export$cc95aa3f6ea8e5cb);
const $add2d86084023c49$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("bqsDF", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", () => $5735b24edb83215a$export$86db56030b57ba34);

var $bZsxw = parcelRequire("bZsxw");

var $2OjhD = parcelRequire("2OjhD");
const $5735b24edb83215a$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $bZsxw.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $2OjhD.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $2OjhD.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $2OjhD.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $2OjhD.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $2OjhD.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("e12ut", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $b1d94387f599e941$export$b88d990436be0f8a);
const $b1d94387f599e941$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("c4WOp", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $5709718468179f7d$export$2878bf482e539059);

var $bZsxw = parcelRequire("bZsxw");

var $2OjhD = parcelRequire("2OjhD");
const $5709718468179f7d$var$getThreshold = (isInitial, metric)=>{
    return (0, $2OjhD.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $5709718468179f7d$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $5709718468179f7d$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $bZsxw.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $2OjhD.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $5709718468179f7d$var$getHistogram(data.isInitial, (0, $2OjhD.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $5709718468179f7d$var$getHistogram(data.isInitial, (0, $2OjhD.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $5709718468179f7d$var$getHistogram(data.isInitial, (0, $2OjhD.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $5709718468179f7d$var$getHistogram(data.isInitial, (0, $2OjhD.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $5709718468179f7d$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $5709718468179f7d$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});

parcelRegister("cecKe", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $e878bbf4c7475a57$export$ba86cb47f2f22db5);

var $7cRo8 = parcelRequire("7cRo8");

var $bZsxw = parcelRequire("bZsxw");

var $2OjhD = parcelRequire("2OjhD");
const $e878bbf4c7475a57$var$getThreshold = (isInitial, metric)=>{
    return (0, $2OjhD.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $e878bbf4c7475a57$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $e878bbf4c7475a57$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $bZsxw.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $2OjhD.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $e878bbf4c7475a57$var$getHistogram(data.isInitial, (0, $2OjhD.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $e878bbf4c7475a57$var$getHistogram(data.isInitial, (0, $2OjhD.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $e878bbf4c7475a57$var$getHistogram(data.isInitial, (0, $2OjhD.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $e878bbf4c7475a57$var$getHistogram(data.isInitial, (0, $2OjhD.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $e878bbf4c7475a57$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $e878bbf4c7475a57$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $2OjhD.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $2OjhD.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $7cRo8.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $2OjhD.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("3CL6l", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", () => $652c6f042ecfbc5f$export$3731db279f590f30);

var $faqZ3 = parcelRequire("faqZ3");

var $fCzt4 = parcelRequire("fCzt4");

var $bC5TE = parcelRequire("bC5TE");

var $aklN4 = parcelRequire("aklN4");
const $652c6f042ecfbc5f$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $faqZ3.PageVisibleState).MIXED;
    };
    (0, $fCzt4.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await $652c6f042ecfbc5f$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $fCzt4.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $aklN4.pageVisibleValue)(config, data, globalConfig)
    };
};
const $652c6f042ecfbc5f$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $bC5TE.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $bC5TE.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $bC5TE.webVitalsObserver).data;
};

});
parcelRegister("aklN4", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", () => $166fc81eec453bf7$export$177b923114656380);

var $faqZ3 = parcelRequire("faqZ3");
var $2OjhD = parcelRequire("2OjhD");
const $166fc81eec453bf7$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $2OjhD.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $faqZ3.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("fOBx2", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $7c7f0b0122360f2b$export$723b4c298aca63af);
const $7c7f0b0122360f2b$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("6FD20", function(module, exports) {

$parcel$export(module.exports, "productCustomData", () => $d71002744d91ac87$export$fa2af6e412815a74);
const $d71002744d91ac87$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("lgaHS", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $4df746887e3c55a7$export$fdbea518c19dfa8);

var $2OjhD = parcelRequire("2OjhD");
const $4df746887e3c55a7$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $4df746887e3c55a7$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $2OjhD.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $2OjhD.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $2OjhD.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $4df746887e3c55a7$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("3Rrh2", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $ccf848c1503bcb30$export$a3dc8251cf55b2e0);
const $ccf848c1503bcb30$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("7hfO8", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", () => $5b4b49b00929873c$export$386b10ac64a50b1);

var $4XKM3 = parcelRequire("4XKM3");
const $5b4b49b00929873c$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});

parcelRegister("glqAF", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", () => $9eabb6050555fa45$export$9f84cb359ed29139);
const $9eabb6050555fa45$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("fNOPT", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", () => $a8d8496e21704efb$export$496c14d72b257e07);
const $a8d8496e21704efb$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("j3CL9", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", () => $97af46a2100383e5$export$88bf7b55f7fc4e8e);
const $97af46a2100383e5$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("5qhne", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $d403b3630c7eca6f$export$e952f50a4f2d02da);

var $2OjhD = parcelRequire("2OjhD");

var $a83l4 = parcelRequire("a83l4");

var $gKqV5 = parcelRequire("gKqV5");
const $d403b3630c7eca6f$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $2OjhD.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $a83l4.customTimings)(config, data);
    const ssr = config.type === (0, $2OjhD.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $gKqV5.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("a83l4", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $d861c161712d83ed$export$6126f85083a72c6e);

const $d861c161712d83ed$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $d861c161712d83ed$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $d861c161712d83ed$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $d861c161712d83ed$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $636842cf8e8f850b$export$b98e411ae80c806f)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
const $636842cf8e8f850b$export$b98e411ae80c806f = '/';


parcelRegister("gKqV5", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $4eac1f1b5e5e13f8$export$130f411261a599c5);

const $4eac1f1b5e5e13f8$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $4eac1f1b5e5e13f8$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $4eac1f1b5e5e13f8$var$SSR_PREFIX = 'ssr';
const $4eac1f1b5e5e13f8$var$mapKey = (key)=>{
    if (key === 'total') return $4eac1f1b5e5e13f8$var$SSR_PREFIX;
    return `${$4eac1f1b5e5e13f8$var$SSR_PREFIX}${0, $636842cf8e8f850b$export$b98e411ae80c806f}${key}`;
};
const $4eac1f1b5e5e13f8$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($4eac1f1b5e5e13f8$var$filterEntry(entry[1])) acc[$4eac1f1b5e5e13f8$var$mapKey(entry[0])] = $4eac1f1b5e5e13f8$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("7nZqE", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $d63b06bb3b343068$export$1a2bb347935fc536);
const $d63b06bb3b343068$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $d63b06bb3b343068$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($d63b06bb3b343068$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("9sxxV", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $103f343fd312afd6$export$81a7d52441a06b50);
const $103f343fd312afd6$var$cacheableTypes = [
    'script',
    'link'
];
const $103f343fd312afd6$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $103f343fd312afd6$var$CACHE_NETWORK = 'network';
const $103f343fd312afd6$var$CACHE_MEMORY = 'memory';
const $103f343fd312afd6$var$CACHE_DISK = 'disk';
const $103f343fd312afd6$var$calculateTransferType = (type, duration, size)=>{
    if (!$103f343fd312afd6$var$cacheableTypes.includes(type)) return $103f343fd312afd6$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $103f343fd312afd6$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $103f343fd312afd6$var$CACHE_DISK;
    if (size === undefined) return null;
    return $103f343fd312afd6$var$CACHE_NETWORK;
};
const $103f343fd312afd6$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$103f343fd312afd6$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $103f343fd312afd6$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $103f343fd312afd6$var$withoutHeaders = ()=>false;
const $103f343fd312afd6$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $103f343fd312afd6$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $103f343fd312afd6$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $103f343fd312afd6$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $103f343fd312afd6$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $103f343fd312afd6$var$getNetworkData = (item, eventStart, hasTimingHeaders = $103f343fd312afd6$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$103f343fd312afd6$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($103f343fd312afd6$var$cacheableTypes.includes(type)) {
        const transferType = $103f343fd312afd6$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$103f343fd312afd6$var$getSizeObject(size)
        };
        if (transferType !== $103f343fd312afd6$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$103f343fd312afd6$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$103f343fd312afd6$var$getSizeObject(size)
    };
};
const $103f343fd312afd6$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $103f343fd312afd6$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $103f343fd312afd6$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$103f343fd312afd6$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$103f343fd312afd6$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("iFc5T", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", () => $e210a9ede499ed9e$export$5b4fb14409a2a825);

var $2OjhD = parcelRequire("2OjhD");
const $e210a9ede499ed9e$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $e210a9ede499ed9e$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $2OjhD.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($e210a9ede499ed9e$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $e210a9ede499ed9e$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $2OjhD.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $2OjhD.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $2OjhD.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $2OjhD.BMEventsType).PAGE_LOAD]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2OjhD.BMEventsType).PAGE_LOAD]),
        [(0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $2OjhD.BMEventsType).INLINE_RESULT]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2OjhD.BMEventsType).INLINE_RESULT]),
        [(0, $2OjhD.BMEventsType).CUSTOM]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2OjhD.BMEventsType).CUSTOM]),
        [(0, $2OjhD.BMEventsType).WEB_VITALS]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2OjhD.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("eoXiD", function(module, exports) {

$parcel$export(module.exports, "ufologger", () => $571cc62004c36239$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $571cc62004c36239$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $571cc62004c36239$export$d53d07b6034c4560);
class $571cc62004c36239$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($571cc62004c36239$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($571cc62004c36239$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $571cc62004c36239$export$4ab84f6f04f6566d = new $571cc62004c36239$var$UFOLogger();
const $571cc62004c36239$export$b4958caff08a0960 = (...args)=>{
    $571cc62004c36239$export$4ab84f6f04f6566d.log(...args);
};
const $571cc62004c36239$export$d53d07b6034c4560 = (...args)=>{
    $571cc62004c36239$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("8Nn2p", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $9591752280ca5b01$export$15e172712955e18f);
const $9591752280ca5b01$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("iJHxx", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $db239cdfaae621d7$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $db239cdfaae621d7$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $db239cdfaae621d7$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $db239cdfaae621d7$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $db239cdfaae621d7$export$7c957416596ca127);

var $eoXiD = parcelRequire("eoXiD");

var $fSTSz = parcelRequire("fSTSz");
const $db239cdfaae621d7$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $db239cdfaae621d7$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $db239cdfaae621d7$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $db239cdfaae621d7$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $eoXiD.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $db239cdfaae621d7$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $fSTSz.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $db239cdfaae621d7$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $fSTSz.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $db239cdfaae621d7$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $fSTSz.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("fSTSz", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $aa871f66b1a2d453$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $aa871f66b1a2d453$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $aa871f66b1a2d453$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $aa871f66b1a2d453$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $aa871f66b1a2d453$export$837e0f79a8056912);
var $aa871f66b1a2d453$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $aa871f66b1a2d453$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $aa871f66b1a2d453$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $aa871f66b1a2d453$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $aa871f66b1a2d453$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $aa871f66b1a2d453$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $aa871f66b1a2d453$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $aa871f66b1a2d453$export$9f2bf58999404c75 = 'fmp';
const $aa871f66b1a2d453$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("3aRrh", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $0f64fa92f0a44c04$export$13e680397ec8f3eb);

var $8Nn2p = parcelRequire("8Nn2p");
class $0f64fa92f0a44c04$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $8Nn2p.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $0f64fa92f0a44c04$export$13e680397ec8f3eb = new $0f64fa92f0a44c04$var$VisibilityChangeObserver();

});

parcelRegister("atdLB", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $648975f2f02f5db7$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $648975f2f02f5db7$export$cc26007c03242fff);
var $648975f2f02f5db7$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $648975f2f02f5db7$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("kRatU", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("9PqPj")).default);

var $9PqPj = parcelRequire("9PqPj");

var $bECnN = parcelRequire("bECnN");

});
parcelRegister("9PqPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0fec51a21ec5a78$export$2e2bcd8739ae039);

var $bECnN = parcelRequire("bECnN");

var $jSerw = parcelRequire("jSerw");

var $furey = parcelRequire("furey");

var $bo3Uw = parcelRequire("bo3Uw");
class $b0fec51a21ec5a78$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $jSerw.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $jSerw.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $bo3Uw.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $furey.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $jSerw.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $bECnN.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $bECnN.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $bECnN.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $jSerw.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $jSerw.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $bECnN.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $jSerw.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $bECnN.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("bECnN", function(module, exports) {

$parcel$export(module.exports, "ExposureTriggerReason", () => $0ceddc1f24830f6f$export$2c20ffeba7dbc068);
var $0ceddc1f24830f6f$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("jSerw", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $8918e231cb30b34e$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $8918e231cb30b34e$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $8918e231cb30b34e$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $8918e231cb30b34e$export$891630e169ca14a4);
const $8918e231cb30b34e$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $8918e231cb30b34e$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $8918e231cb30b34e$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $8918e231cb30b34e$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $8918e231cb30b34e$var$validateFlag = (flagKey, flag)=>{
    if ($8918e231cb30b34e$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $8918e231cb30b34e$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$8918e231cb30b34e$var$validateFlag(key, flags[key]));
};

});

parcelRegister("furey", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7101c4822b75c1$export$2e2bcd8739ae039);
const $7c7101c4822b75c1$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $7c7101c4822b75c1$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $7c7101c4822b75c1$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("bo3Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7d7cbcbf7ac517$export$2e2bcd8739ae039);

var $bECnN = parcelRequire("bECnN");
class $9b7d7cbcbf7ac517$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $bECnN.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $bECnN.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});



parcelRegister("49z18", function(module, exports) {

$parcel$export(module.exports, "payloadPublisher", () => $02c157c65157adaa$export$edb879ae55bb9be3);

var $atdLB = parcelRequire("atdLB");
var $3aRrh = parcelRequire("3aRrh");

var $iJHxx = parcelRequire("iJHxx");

var $eoXiD = parcelRequire("eoXiD");

var $fSTSz = parcelRequire("fSTSz");


var $9na5h = parcelRequire("9na5h");

var $cnlxp = parcelRequire("cnlxp");

var $ep4ut = parcelRequire("ep4ut");

var $jdaZR = parcelRequire("jdaZR");

var $dFbEk = parcelRequire("dFbEk");

var $1rlqb = parcelRequire("1rlqb");

var $8vdI1 = parcelRequire("8vdI1");

var $7xyGJ = parcelRequire("7xyGJ");

var $6IMTA = parcelRequire("6IMTA");

var $dc6Kb = parcelRequire("dc6Kb");

var $aHGCE = parcelRequire("aHGCE");

var $l4Z6i = parcelRequire("l4Z6i");

var $4btcP = parcelRequire("4btcP");

var $foo60 = parcelRequire("foo60");

var $e1BKK = parcelRequire("e1BKK");

var $dK6It = parcelRequire("dK6It");

var $8Vhtb = parcelRequire("8Vhtb");
const $02c157c65157adaa$var$UNKNOWN_VALUE = 'unknown';
const $02c157c65157adaa$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $02c157c65157adaa$var$UNKNOWN_VALUE,
    id: $02c157c65157adaa$var$UNKNOWN_VALUE,
    uuid: $02c157c65157adaa$var$UNKNOWN_VALUE,
    state: {
        id: $02c157c65157adaa$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $atdLB.ExperienceTypes).Experience,
    category: $02c157c65157adaa$var$UNKNOWN_VALUE,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $fSTSz.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $02c157c65157adaa$var$Publisher {
    publish(data) {
        const payloadStart = (0, $8Vhtb.getPerformanceObject)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $eoXiD.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$02c157c65157adaa$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $46f5b02486779691$export$93809551debf385f) || $02c157c65157adaa$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $7xyGJ.eventBrowserPlugin)(),
                    ...(0, $6IMTA.eventCpusPlugin)(),
                    ...(0, $aHGCE.eventMemoryPlugin)(),
                    ...(0, $l4Z6i.eventNetworkPlugin)(),
                    ...(0, $1rlqb.appFramework)(this.app),
                    ...(0, $8vdI1.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $9na5h.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $jdaZR.pageVisibleState)(supportedData),
                    ...(0, $dK6It.isInitialPageLoad)(supportedData) && (0, $foo60.ssrSuccess)(this.ssr),
                    ...(0, $dK6It.isInitialPageLoad)(supportedData) && (0, $4btcP.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $dc6Kb.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: this.getPerformanceMetrics(supportedData),
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $8Vhtb.getPerformanceObject)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $eoXiD.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $iJHxx.getGlobalEventStream)() instanceof (0, $cnlxp.UFOGlobalEventStream))) {
            const eventStream = new (0, $cnlxp.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $fSTSz.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $iJHxx.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $3aRrh.visibilityChangeObserver).start();
        (0, $dFbEk.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $ep4ut.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $02c157c65157adaa$var$UNKNOWN_VALUE;
        this.hostname = (0, $8Vhtb.getWindowObject)()?.location?.hostname || '';
        this.tenantType = (0, $9na5h.TenantType).RealUser;
        this.app = {
            version: {
                web: $02c157c65157adaa$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $e1BKK.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $02c157c65157adaa$export$edb879ae55bb9be3 = new $02c157c65157adaa$var$Publisher();

});
// temp solution until a proper versioning
const $46f5b02486779691$export$93809551debf385f = '0.1.7';

parcelRegister("9na5h", function(module, exports) {

$parcel$export(module.exports, "TenantType", () => $5c9ba10207f863ae$export$92a757ac1398962f);

var $5c9ba10207f863ae$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("cnlxp", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStream", () => $a15afbfb62c8af6a$export$faf4c91b80fc830e);

var $eoXiD = parcelRequire("eoXiD");

var $fSTSz = parcelRequire("fSTSz");
class $a15afbfb62c8af6a$export$faf4c91b80fc830e {
    push(event) {
        (0, $eoXiD.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $fSTSz.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $fSTSz.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $fSTSz.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $fSTSz.SUBSCRIBE_ALL]) this.subscribers[0, $fSTSz.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $eoXiD.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("ep4ut", function(module, exports) {

$parcel$export(module.exports, "getPerformancePayload", () => $d4de3328a66dae38$export$738d24377baf6a5e);

var $atdLB = parcelRequire("atdLB");

var $fSTSz = parcelRequire("fSTSz");

var $dK6It = parcelRequire("dK6It");

var $kWdyU = parcelRequire("kWdyU");

var $k4Pve = parcelRequire("k4Pve");

var $eAj4U = parcelRequire("eAj4U");

var $h6gEY = parcelRequire("h6gEY");
const $d4de3328a66dae38$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $d4de3328a66dae38$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $d4de3328a66dae38$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $d4de3328a66dae38$var$getHistogram = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $atdLB.ExperiencePerformanceTypes).PageLoad:
            case (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$d4de3328a66dae38$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$d4de3328a66dae38$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $atdLB.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$d4de3328a66dae38$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$d4de3328a66dae38$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $atdLB.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$d4de3328a66dae38$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
};
const $d4de3328a66dae38$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $fSTSz.FMP_MARK))?.time || (0, $dK6It.isInitialPageLoad)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$d4de3328a66dae38$var$LoadMetricKeys.tti]: Math.round(tti),
        [$d4de3328a66dae38$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$d4de3328a66dae38$var$getHistogram(data, performanceConfig)
    };
};
const $d4de3328a66dae38$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $fSTSz.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$d4de3328a66dae38$var$InlineResultMetricKeys.result]: Math.round(result),
        [$d4de3328a66dae38$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$d4de3328a66dae38$var$getHistogram(data, performanceConfig)
    };
};
const $d4de3328a66dae38$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$d4de3328a66dae38$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$d4de3328a66dae38$var$getHistogram(data, performanceConfig)
    };
};
const $d4de3328a66dae38$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $atdLB.ExperiencePerformanceTypes).PageLoad:
        case (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad:
            return $d4de3328a66dae38$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $atdLB.ExperiencePerformanceTypes).InlineResult:
            return $d4de3328a66dae38$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $atdLB.ExperiencePerformanceTypes).Custom:
            return $d4de3328a66dae38$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $d4de3328a66dae38$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$d4de3328a66dae38$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $h6gEY.resourceTimings)(data, resourceConfig),
        ...(0, $eAj4U.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $k4Pve.appTimings)(data, ssr),
        ...(0, $dK6It.isInitialPageLoad)(data) ? (0, $kWdyU.navigationMetrics)() : null
    };
};

});
parcelRegister("dK6It", function(module, exports) {

$parcel$export(module.exports, "isInitialPageLoad", () => $0b4a58e4d2769f2b$export$7167d96e9881d500);

var $atdLB = parcelRequire("atdLB");
const $0b4a58e4d2769f2b$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $atdLB.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("kWdyU", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $c5ac08be6ac9d8e8$export$b88d990436be0f8a);
const $c5ac08be6ac9d8e8$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("k4Pve", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $78cb488cd4728639$export$e952f50a4f2d02da);

var $atdLB = parcelRequire("atdLB");

var $dK6It = parcelRequire("dK6It");

var $86du4 = parcelRequire("86du4");

var $gtOjE = parcelRequire("gtOjE");
const $78cb488cd4728639$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $atdLB.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $86du4.customTimings)(data);
    const ssr = (0, $dK6It.isInitialPageLoad)(data) ? (0, $gtOjE.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("86du4", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $8b95ee7a7ad3b9c4$export$6126f85083a72c6e);
const $8b95ee7a7ad3b9c4$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $8b95ee7a7ad3b9c4$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $8b95ee7a7ad3b9c4$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("gtOjE", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $8088f1c47096c2e3$export$130f411261a599c5);

const $8088f1c47096c2e3$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $8088f1c47096c2e3$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $8088f1c47096c2e3$var$SSR_PREFIX = 'ssr';
const $8088f1c47096c2e3$var$mapKey = (key)=>{
    if (key === 'total') return $8088f1c47096c2e3$var$SSR_PREFIX;
    return `${$8088f1c47096c2e3$var$SSR_PREFIX}${0, $088984e189011c8c$export$b98e411ae80c806f}${key}`;
};
const $8088f1c47096c2e3$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($8088f1c47096c2e3$var$filterEntry(entry[1])) acc[$8088f1c47096c2e3$var$mapKey(entry[0])] = $8088f1c47096c2e3$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
const $088984e189011c8c$export$b98e411ae80c806f = '/';



parcelRegister("eAj4U", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $4fa9087c35bbbe76$export$1a2bb347935fc536);

var $8Vhtb = parcelRequire("8Vhtb");
const $4fa9087c35bbbe76$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $8Vhtb.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("8Vhtb", function(module, exports) {

$parcel$export(module.exports, "getWindowObject", () => $17273a97381df088$export$9aa44f85591248d9);
$parcel$export(module.exports, "getPerformanceObject", () => $17273a97381df088$export$8cd0c777b0eb66a0);
$parcel$export(module.exports, "getPerformanceObserverObject", () => $17273a97381df088$export$74560fd4e61fd440);
const $17273a97381df088$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $17273a97381df088$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $17273a97381df088$export$9aa44f85591248d9() || {};
    return performance;
};
const $17273a97381df088$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $17273a97381df088$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};

});


parcelRegister("h6gEY", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $260cdb61c1527b3f$export$81a7d52441a06b50);

var $8Vhtb = parcelRequire("8Vhtb");

var $dFbEk = parcelRequire("dFbEk");
const $260cdb61c1527b3f$var$cacheableTypes = [
    'script',
    'link'
];
const $260cdb61c1527b3f$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $260cdb61c1527b3f$var$CACHE_NETWORK = 'network';
const $260cdb61c1527b3f$var$CACHE_MEMORY = 'memory';
const $260cdb61c1527b3f$var$CACHE_DISK = 'disk';
const $260cdb61c1527b3f$var$calculateTransferType = (type, duration, size)=>{
    if (!$260cdb61c1527b3f$var$cacheableTypes.includes(type)) return $260cdb61c1527b3f$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $260cdb61c1527b3f$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $260cdb61c1527b3f$var$CACHE_DISK;
    if (size === undefined) return null;
    return $260cdb61c1527b3f$var$CACHE_NETWORK;
};
const $260cdb61c1527b3f$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$260cdb61c1527b3f$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $8Vhtb.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $260cdb61c1527b3f$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $260cdb61c1527b3f$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $260cdb61c1527b3f$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $260cdb61c1527b3f$var$getNetworkData = (item, eventStart, hasTimingHeaders = $260cdb61c1527b3f$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$260cdb61c1527b3f$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($260cdb61c1527b3f$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $260cdb61c1527b3f$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$260cdb61c1527b3f$var$getSizeObject(transferSize)
        };
        if (transferType !== $260cdb61c1527b3f$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$260cdb61c1527b3f$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$260cdb61c1527b3f$var$getSizeObject(transferSize)
    };
};
const $260cdb61c1527b3f$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $8Vhtb.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $dFbEk.getResourceTimings)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $260cdb61c1527b3f$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $260cdb61c1527b3f$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$260cdb61c1527b3f$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("dFbEk", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $f5d2a8d6860f3f5c$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $f5d2a8d6860f3f5c$export$9eebb59359c2e9e5);
// @flow strict-local

var $eoXiD = parcelRequire("eoXiD");

var $8Vhtb = parcelRequire("8Vhtb");
const $f5d2a8d6860f3f5c$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $8Vhtb.getPerformanceObject)(), PerformanceObserver1 = (0, $8Vhtb.getPerformanceObserverObject)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($f5d2a8d6860f3f5c$export$bea963256235a63e.observer) {
            (0, $eoXiD.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $f5d2a8d6860f3f5c$export$bea963256235a63e.timings = resources.map((resource)=>$f5d2a8d6860f3f5c$export$bea963256235a63e.transformResource(resource));
        $f5d2a8d6860f3f5c$export$bea963256235a63e.observer = new PerformanceObserver1($f5d2a8d6860f3f5c$export$bea963256235a63e.addTimings);
        $f5d2a8d6860f3f5c$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($f5d2a8d6860f3f5c$export$bea963256235a63e.observer) {
            $f5d2a8d6860f3f5c$export$bea963256235a63e.observer.disconnect();
            $f5d2a8d6860f3f5c$export$bea963256235a63e.observer = null;
        }
        $f5d2a8d6860f3f5c$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$f5d2a8d6860f3f5c$export$bea963256235a63e.transformResource(entry));
        const overflow = $f5d2a8d6860f3f5c$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $f5d2a8d6860f3f5c$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $f5d2a8d6860f3f5c$export$bea963256235a63e.maxSize;
            $f5d2a8d6860f3f5c$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $f5d2a8d6860f3f5c$export$bea963256235a63e.timings.push(...entries);
    }
};
const $f5d2a8d6860f3f5c$export$9eebb59359c2e9e5 = (startTime, performance = (0, $8Vhtb.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$f5d2a8d6860f3f5c$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $f5d2a8d6860f3f5c$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});



parcelRegister("jdaZR", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $a63b5db026909530$export$723b4c298aca63af);

var $fSTSz = parcelRequire("fSTSz");
const $a63b5db026909530$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $fSTSz.PageVisibleState).HIDDEN : (0, $fSTSz.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("1rlqb", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $21d864dabdcdfb99$export$e34e4529b979f74c);
const $21d864dabdcdfb99$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("8vdI1", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $8f2169abe7fc39d7$export$82ae485178b37419);
const $8f2169abe7fc39d7$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("7xyGJ", function(module, exports) {

$parcel$export(module.exports, "eventBrowserPlugin", () => $0b31bf64269c47f7$export$f435c2789ca334a7);

var $4XKM3 = parcelRequire("4XKM3");

var $8QpSo = parcelRequire("8QpSo");

var $8Vhtb = parcelRequire("8Vhtb");
const $0b31bf64269c47f7$export$f435c2789ca334a7 = (0, $8QpSo.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser((0, $8Vhtb.getWindowObject)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("6IMTA", function(module, exports) {

$parcel$export(module.exports, "eventCpusPlugin", () => $1f74a632b6b19522$export$db7649b8854107ad);

var $8QpSo = parcelRequire("8QpSo");
const $1f74a632b6b19522$export$db7649b8854107ad = (0, $8QpSo.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("dc6Kb", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $2bd20537fe6c7bf9$export$e62953d023125748);
const $2bd20537fe6c7bf9$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("aHGCE", function(module, exports) {

$parcel$export(module.exports, "eventMemoryPlugin", () => $f0ec20b3c2496535$export$81efaf8414879a1a);

var $8QpSo = parcelRequire("8QpSo");
const $f0ec20b3c2496535$export$81efaf8414879a1a = (0, $8QpSo.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("l4Z6i", function(module, exports) {

$parcel$export(module.exports, "eventNetworkPlugin", () => $3b5d10e1054ac5c5$export$ce1cf816dce1da56);
const $3b5d10e1054ac5c5$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("4btcP", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $4d6e8c27f9546e1d$export$fdbea518c19dfa8);
const $4d6e8c27f9546e1d$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("foo60", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $5bf66f80ee72a63e$export$a3dc8251cf55b2e0);
const $5bf66f80ee72a63e$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("e1BKK", function(module, exports) {

$parcel$export(module.exports, "Route", () => $3acce3639a350de3$export$e7b0ac011bb776c6);
const $3acce3639a350de3$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});


const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';

const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $b2e0d12d54fddedd$export$cf090d5281b5ae06 = 10000;
const $b2e0d12d54fddedd$export$8575e30be0feb909 = 30000;

const $da88f8f66d8f0f0a$export$3288b14b6745c572 = 204;
const $da88f8f66d8f0f0a$export$c09e7ea0fc79f34f = 409;
const $da88f8f66d8f0f0a$export$974c37534b0191b1 = 503;


$parcel$global.rlb("i5RRW")
//# sourceMappingURL=shared~commons~atlassian~ar.d2521a3e.js.map
